module.exports = __webpack_public_path__ + "img/blank-notification.7f1f557f.svg";